import type { TOC } from '@ember/component/template-only';
import DocumentCenter from 'tio-employee/components/reimagined/document-center';
import type { DocumentCenterModel } from 'tio-employee/components/reimagined/document-center';

export type ReimaginedDocumentCenterModel = DocumentCenterModel;

interface Signature {
  Args: { model: ReimaginedDocumentCenterModel };
}

const template: TOC<Signature> = <template>
  <DocumentCenter @model={{@model}} @variant="production" />
</template>;

export default template;
